(() => {
  if (window.nhCountryDetection) return;
  window.nhCountryDetection = true;
  const context = document.getElementById('nh-country-context');
  if (!context) return;
  let config;
  try { config = JSON.parse(context.textContent); } catch { return; }
  if (config.designMode) return;
  const key = 'nh_delivery_country_v1';
  const checkedKey = 'nh_country_checked_v1';
  const form = document.getElementById(config.formId);
  if (!form) return;
  let manualChoice = false;
  const readChoice = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || 'null');
      return value && value.expires > Date.now() && config.countries.includes(value.country) ? value.country : null;
    } catch { return null; }
  };
  document.addEventListener('submit', (event) => {
    const country = event.submitter?.name === 'country_code' ? event.submitter.value : null;
    if (!country || !config.countries.includes(country)) return;
    manualChoice = true;
    try {
      localStorage.setItem(key, JSON.stringify({country, expires: Date.now() + 180 * 86400000}));
    } catch {}
  }, true);
  const setCountry = (country) => {
    if (manualChoice || !country || country === config.country || !config.countries.includes(country)) return;
    const input = form.querySelector('input[name="country_code"]');
    if (!input) return;
    input.value = country;
    form.submit();
  };
  const saved = readChoice();
  if (saved) { setCountry(saved); return; }
  try {
    if (sessionStorage.getItem(checkedKey)) return;
    sessionStorage.setItem(checkedKey, '1');
  } catch { return; }
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {
    credentials: 'same-origin', signal: AbortSignal.timeout(5000)
  }).then(response => response.ok ? response.json() : null).then(data => {
    if (manualChoice || readChoice()) return;
    setCountry(data?.detected_values?.country?.handle);
  }).catch(() => {});
})();
